import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumberInputFormatLegacy]',
})
export class NumberInputFormatLegacyDirective {
  @Input('appNumberInputFormatLegacy') separator = '.';
  @Input() allowComma = true;

  constructor(private el: ElementRef, private control: NgControl, private renderer: Renderer2) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = this.el.nativeElement;
    const formattedValue = this.formatIndonesianNumber(input.value);
    this.renderer.setProperty(this.el.nativeElement, 'value', formattedValue);
    this.control?.control?.setValue(formattedValue);
  }

  formatIndonesianNumber(value: string): string {
    if (!value) return ''; // Handle empty input
    // Allow only digits and at most one comma
    let cleanValue = this.allowComma ? value.replace(/[^0-9,]*/g, '') : value.replace(/[^0-9]/g, '');

    if (this.allowComma) {
      // Ensure only one comma is present
      const parts = cleanValue.split(',');
      let integerPart = parts[0] || '';
      let decimalPart = parts.length > 1 ? ',' + parts[1].substring(0, 3) : ''; // Limit to 3 decimal places

      // Convert integer part to number and format using Intl
      let formattedInteger = Intl.NumberFormat('id-ID').format(Number(integerPart));

      return formattedInteger + decimalPart;
    }

    // else Format as an integer without decimals
    return Intl.NumberFormat('id-ID').format(Number(cleanValue));
  }
}
